import { Snackbar, Alert, Box } from '@mui/material';
import type { AdminMessage } from './types';

interface MessageSnackbarProps {
  message: AdminMessage | null;
  onClose: () => void;
}

export default function MessageSnackbar({ message, onClose }: MessageSnackbarProps) {
  return (
    <Snackbar
      open={!!message}
      autoHideDuration={message?.type === 'error' ? 10000 : 6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={message?.type === 'success' ? 'success' : message?.type === 'warning' ? 'warning' : 'error'}
        onClose={onClose}
        sx={{ width: '100%', maxWidth: '600px', whiteSpace: 'pre-wrap' }}
      >
        {message?.text}
        {message?.details != null && (
          <Box component="div" sx={{ mt: 1, fontSize: '0.875rem', opacity: 0.9, maxHeight: '300px', overflowY: 'auto' }}>
            {message.details}
          </Box>
        )}
      </Alert>
    </Snackbar>
  );
}
